export const formattingOptionsTooltip = "e0b";
export default {formattingOptionsTooltip};